import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { capi, apiError } from "@/lib/api";
import { AuthCard, FieldLabel, Notice, inputCls, btnCls } from "@/components/account/AuthCard";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [f, setF] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (f.password.length < 8) { setErr("Password must be at least 8 characters."); return; }
    if (f.password !== f.confirm) { setErr("Passwords don't match."); return; }
    setBusy(true);
    try {
      await capi.post("/account/reset-password", { token: params.get("token") || "", password: f.password });
      setDone(true);
    } catch (e2) { setErr(apiError(e2)); }
    finally { setBusy(false); }
  };

  return (
    <AuthCard title="Choose a new password" testid="reset-password-page">
      {done ? (
        <div data-testid="reset-success">
          <Notice kind="info">Your password has been reset.</Notice>
          <Link to="/account/login" className="inline-flex rounded-full bg-kys-ink px-6 py-3 text-sm font-semibold text-white hover:bg-kys-accent">Sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {err && <Notice testid="reset-error">{err}</Notice>}
          <div><FieldLabel>New password (8+ characters)</FieldLabel><input data-testid="reset-password" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={inputCls} /></div>
          <div><FieldLabel>Confirm new password</FieldLabel><input data-testid="reset-confirm" type="password" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} className={inputCls} /></div>
          <button data-testid="reset-submit" disabled={busy} className={btnCls}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset password"}</button>
        </form>
      )}
    </AuthCard>
  );
}
